import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import db from "../../config/firebase";
import { sample } from "../../sample";

export const useChallenges = (challengeIndex: string) => {
  const docRef = doc(db, "challenges", challengeIndex);
  const [docDetails, loading, error] = useDocument(docRef);
  const docData = docDetails?.data() || sample;

  if (error) {
    console.error(error);
    throw error;
  }

  return { docData, loading };
};
